import { render, staticRenderFns } from "./trafficQueryList.vue?vue&type=template&id=856b70ce&scoped=true"
import script from "./trafficQueryList.vue?vue&type=script&lang=js"
export * from "./trafficQueryList.vue?vue&type=script&lang=js"
import style0 from "./trafficQueryList.vue?vue&type=style&index=0&id=856b70ce&prod&scoped=true&lang=css"
import style1 from "./trafficQueryList.vue?vue&type=style&index=1&id=856b70ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856b70ce",
  null
  
)

export default component.exports